import administracionEmpresa2 from "./administracion_empresa_2.jpg";
import adminitracionEmpresa from "./adminitracion_empresa.jpg";
import areaIndustrial from "./area_industrial.jpg";
import construccion from "./construccion.jpg";
import educacion from "./educacion.jpg";
import mineria from "./mineria.jpg";
import mineria2 from "./mineria_2.jpg";
import salud from "./salud.jpg";
import transporte from "./transporte.jpg";

const imageList = [
  administracionEmpresa2,
  adminitracionEmpresa,
  areaIndustrial,
  construccion,
  educacion,
  mineria,
  mineria2,
  salud,
  transporte,
];

export function getRandomBgImage() {
  const idx = Math.floor(Math.random() * imageList.length);
  return imageList[idx];
}

export function getRandomBgImages(count = 4) {
  const shuffled = [...imageList].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
}

export default imageList;
